<template>
    <ul class="audit-log">
        <li v-if="this.auditLog.order_submitted">Order submitted by : {{ this.auditLog.order_submitted.name }} at {{ this.auditLog.order_submitted.date }}</li>
        <li v-if="this.auditLog.order_edited">Last edited by : {{ this.auditLog.order_edited.name }} at {{ this.auditLog.order_edited.date }}<span>.</span></li>
    </ul>
</template>

<script>
export default {
    name: 'BaxOrderAuditDetail',
    props: {
        order: {
            required: true,
        },
    },
    data() {
        return {
            auditLog: false,
        };
    },
    mounted() {
        //
        if (this.order.auditTrail) {
            this.auditLog = this.order.auditTrail;
        }
    },
};
</script>
